import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useSettings } from '../contexts/SettingsContext';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AboutPage = () => {
  const { language } = useLanguage();
  const { settings } = useSettings();

  const texts = {
    nl: {
      title: 'Over Ons',
      missionLabel: 'WIE WIJ ZIJN',
      missionTitle: 'Specialist in droogbouwprofielen',
      missionP1: 'AlfaProfiles is een gespecialiseerde fabrikant en leverancier van hoogwaardige droogbouwprofielen en accessoires voor de professionele bouwsector. Vanuit Belgie focussen wij ons op productie, distributie en levering aan groothandels, verdelers en professionele partners binnen de afbouwsector.',
      missionP2: 'Met moderne productietechnologie, technische expertise en een sterke focus op kwaliteit produceren wij betrouwbare metalen profielen voor wand-, plafond- en afwerkingssystemen. Dankzij efficiente productieprocessen en een ruime voorraad kunnen wij constante kwaliteit, korte levertermijnen en flexibele oplossingen aanbieden.',
      rangeLabel: 'ONS ASSORTIMENT',
      range1: 'CD- en UD-plafondprofielen',
      range2: 'CW- en UW-metal stud profielen',
      range3: 'Hoekprofielen en afwerkingsprofielen',
      range4: 'Ankerhangers en accessoires',
      range5: 'Professionele oplossingen op maat',
      visionLabel: 'ONZE WAARDEN',
      visionTitle: 'Kwaliteit, betrouwbaarheid en continuiteit',
      visionText: 'Wij werken uitsluitend met kwalitatieve grondstoffen en streven naar producten die voldoen aan de Europese normen en de hoge verwachtingen van de professionele markt.',
      visionText2: 'AlfaProfiles staat voor kwaliteit, betrouwbaarheid, continuiteit en professionele samenwerking.',
      factsLabel: 'IN CIJFERS',
      f1: 'Productgroepen', f1v: '4',
      f2: 'Artikelen', f2v: '33+',
      f3: 'Verzorgingsgebied', f3v: 'Europa',
      f4: 'Certificering', f4v: 'CE / Z100',
      ctaTitle: 'Meer weten over onze producten?',
      ctaBtn: 'Bekijk ons assortiment',
    },
    en: {
      title: 'About Us',
      missionLabel: 'WHO WE ARE',
      missionTitle: 'Specialist in drywall profiles',
      missionP1: 'AlfaProfiles is a specialized manufacturer and supplier of high-quality drywall profiles and accessories for the professional construction sector. From Belgium, we supply a complete range of metal profiles and accessories for wall, ceiling and finishing systems.',
      missionP2: 'We combine modern production technology, technical expertise and a strong focus on quality to offer reliable solutions for wholesalers, distributors and professional finishing companies. Thanks to efficient production processes and ample stock, we can guarantee fast deliveries and consistent quality.',
      rangeLabel: 'OUR RANGE',
      range1: 'CD and UD ceiling profiles',
      range2: 'CW and UW metal stud profiles',
      range3: 'Corner profiles and finishing profiles',
      range4: 'Anchor hangers and accessories',
      range5: 'Custom solutions for professional applications',
      visionLabel: 'OUR VALUES',
      visionTitle: 'Sustainability, precision and customer focus',
      visionText: 'At AlfaProfiles, sustainability, precision and customer focus are central. We work exclusively with quality raw materials and strive for products that meet European standards and expectations of the modern construction sector.',
      visionText2: 'With strong international sourcing, continuous quality control and professional service, we build lasting partnerships with our customers every day.',
      factsLabel: 'IN NUMBERS',
      f1: 'Product Groups', f1v: '4',
      f2: 'Articles', f2v: '33+',
      f3: 'Service Area', f3v: 'Europe',
      f4: 'Certification', f4v: 'CE / Z100',
      ctaTitle: 'Want to know more about our products?',
      ctaBtn: 'View our range',
    },
    fr: {
      title: 'A Propos',
      missionLabel: 'QUI SOMMES-NOUS',
      missionTitle: 'Specialiste en profils pour cloisons seches',
      missionP1: 'AlfaProfiles est un fabricant et fournisseur specialise de profils pour cloisons seches et d\'accessoires de haute qualite pour le secteur professionnel de la construction. Depuis la Belgique, nous fournissons une gamme complete de profils metalliques et d\'accessoires pour les systemes de murs, plafonds et finitions.',
      missionP2: 'Nous combinons une technologie de production moderne, une expertise technique et une forte orientation qualite pour offrir des solutions fiables aux grossistes, distributeurs et entreprises de finition professionnelles. Grace a des processus de production efficaces et un stock important, nous garantissons des livraisons rapides et une qualite constante.',
      rangeLabel: 'NOTRE GAMME',
      range1: 'Profils de plafond CD et UD',
      range2: 'Profils metal stud CW et UW',
      range3: 'Profils d\'angle et de finition',
      range4: 'Suspentes et accessoires',
      range5: 'Solutions sur mesure pour applications professionnelles',
      visionLabel: 'NOS VALEURS',
      visionTitle: 'Durabilite, precision et orientation client',
      visionText: 'Chez AlfaProfiles, la durabilite, la precision et l\'orientation client sont au coeur de nos activites. Nous travaillons exclusivement avec des matieres premieres de qualite et visons des produits conformes aux normes europeennes.',
      visionText2: 'Avec un sourcing international solide, un controle qualite continu et un service professionnel, nous construisons chaque jour des partenariats durables avec nos clients.',
      factsLabel: 'EN CHIFFRES',
      f1: 'Groupes de Produits', f1v: '4',
      f2: 'Articles', f2v: '33+',
      f3: 'Zone de Service', f3v: 'Europe',
      f4: 'Certification', f4v: 'CE / Z100',
      ctaTitle: 'En savoir plus sur nos produits?',
      ctaBtn: 'Voir notre gamme',
    },
    de: {
      title: 'Uber Uns',
      missionLabel: 'WER WIR SIND',
      missionTitle: 'Spezialist fur Trockenbauprofile',
      missionP1: 'AlfaProfiles ist ein spezialisierter Hersteller und Lieferant hochwertiger Trockenbauprofile und Zubehor fur den professionellen Bausektor. Von Belgien aus liefern wir ein komplettes Sortiment an Metallprofilen und Zubehor fur Wand-, Decken- und Abschlusssysteme.',
      missionP2: 'Wir kombinieren moderne Produktionstechnologie, technisches Fachwissen und einen starken Fokus auf Qualitat, um zuverlassige Losungen fur Grosshandler, Distributoren und professionelle Ausbauunternehmen anzubieten. Dank effizienter Produktionsprozesse und umfangreicher Lagerbestande konnen wir schnelle Lieferungen und gleichbleibende Qualitat garantieren.',
      rangeLabel: 'UNSER SORTIMENT',
      range1: 'CD- und UD-Deckenprofile',
      range2: 'CW- und UW-Metallstanderprofile',
      range3: 'Eckprofile und Abschlussprofile',
      range4: 'Ankerabhanger und Zubehor',
      range5: 'Massgefertigte Losungen fur professionelle Anwendungen',
      visionLabel: 'UNSERE WERTE',
      visionTitle: 'Nachhaltigkeit, Prazision und Kundenorientierung',
      visionText: 'Bei AlfaProfiles stehen Nachhaltigkeit, Prazision und Kundenorientierung im Mittelpunkt. Wir arbeiten ausschliesslich mit qualitativen Rohstoffen und streben Produkte an, die den europaischen Normen und Erwartungen des modernen Bausektors entsprechen.',
      visionText2: 'Mit starkem internationalem Sourcing, kontinuierlicher Qualitatskontrolle und professionellem Service bauen wir taglich langfristige Partnerschaften mit unseren Kunden auf.',
      factsLabel: 'IN ZAHLEN',
      f1: 'Produktgruppen', f1v: '4',
      f2: 'Artikel', f2v: '33+',
      f3: 'Versorgungsgebiet', f3v: 'Europa',
      f4: 'Zertifizierung', f4v: 'CE / Z100',
      ctaTitle: 'Mehr uber unsere Produkte erfahren?',
      ctaBtn: 'Sortiment ansehen',
    },
  };

  const tx = texts[language] || texts.nl;

  const getAboutText = () => {
    const customText = settings[`about_text_${language}`] || settings.about_text_nl;
    if (customText) return customText;
    return `${tx.missionP1}\n\n${tx.missionP2}`;
  };

  return (
    <div data-testid="about-page">
      {/* Header */}
      <section className="bg-[#0F172A] pt-28 pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl lg:text-3xl font-bold text-white tracking-tight">{tx.title}</h1>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <span className="corp-label block mb-3">{tx.missionLabel}</span>
              <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 tracking-tight mb-6">{tx.missionTitle}</h2>
              <p className="text-slate-600 text-sm leading-relaxed mb-4">{tx.missionP1}</p>
              <p className="text-slate-600 text-sm leading-relaxed">{tx.missionP2}</p>
            </div>
            <div>
              <span className="corp-label block mb-3">{tx.rangeLabel}</span>
              <ul className="space-y-3 mb-10">
                {[tx.range1, tx.range2, tx.range3, tx.range4, tx.range5].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-slate-700 text-sm">
                    <div className="w-1.5 h-1.5 bg-[#BE1622] rounded-full mt-1.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <span className="corp-label block mb-3">{tx.visionLabel}</span>
              <h2 className="text-xl font-bold text-slate-900 tracking-tight mb-4">{tx.visionTitle}</h2>
              <p className="text-slate-600 text-sm leading-relaxed mb-3">{tx.visionText}</p>
              <p className="text-slate-600 text-sm leading-relaxed">{tx.visionText2}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Facts */}
      <section className="py-16 bg-[#F8FAFC] border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="corp-label block mb-8">{tx.factsLabel}</span>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-gray-200 border border-gray-200">
            {[{ l: tx.f1, v: tx.f1v }, { l: tx.f2, v: tx.f2v }, { l: tx.f3, v: tx.f3v }, { l: tx.f4, v: tx.f4v }].map((f, i) => (
              <div key={i} className="bg-white p-8 text-center">
                <div className="text-2xl font-bold text-slate-900 tracking-tight mb-1">{f.v}</div>
                <div className="text-xs text-slate-500">{f.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-xl font-bold text-slate-900 tracking-tight mb-6">{tx.ctaTitle}</h2>
          <Link to="/products">
            <button className="inline-flex items-center gap-2 bg-[#BE1622] hover:bg-[#9E111B] text-white font-semibold tracking-wider uppercase text-[11px] px-8 py-4 transition-all">
              {tx.ctaBtn} <ArrowRight className="w-4 h-4" />
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};
